export const RECEIVE_DATA = 'C_BALANCESHEET.RECEIVE_DATA';
export const SET_ERRORS = 'C_BALANCESHEET.SET_ERRORS';

export const receive_data = (owners, resp_data, clientId, promise_awaiting) => ({
  type: RECEIVE_DATA,
  owners,
  resp_data,
  clientId,
  promise_awaiting,
});

export const set_errors = (errors, clientId) => ({
  type: SET_ERRORS,
  errors,
  clientId,
});

// Expose receive_data, set_errors to HM
window.ADV.store_functions = window.ADV.store_functions
  ? Object.assign({}, window.ADV.store_functions, {
      balance_sheet_receive_data: receive_data,
      balance_sheet_set_errors: set_errors,
    })
  : {
      balance_sheet_receive_data: receive_data,
      balance_sheet_set_errors: set_errors,
    };
